import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { extractErrorMessage } from "@/lib/api";
import { useLang } from "@/i18n";
import PublicLayout from "@/components/layout/PublicLayout";
import { toast } from "sonner";

const ForgotPassword = () => {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [devResetUrl, setDevResetUrl] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSubmitted(true);
      if (data?.email_mock_mode && data?.dev_reset_url) {
        setDevResetUrl(data.dev_reset_url);
      }
      toast.success(t("phase2.ifAccountExistsToast"));
    } catch (err) {
      toast.error(extractErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <PublicLayout>
      <div className="tsw-section py-16 max-w-md">
        <div className="mb-8">
          <div className="tsw-overline mb-2">{t("common.login")}</div>
          <h1 className="text-3xl sm:text-4xl font-display font-bold text-slate-900" data-testid="forgot-heading">
            {t("phase2.forgotTitle")}
          </h1>
          <p className="text-slate-600 mt-2">{t("phase2.forgotSub")}</p>
        </div>

        {submitted ? (
          <div className="tsw-card p-6 sm:p-8 space-y-4" data-testid="forgot-success">
            <p className="text-slate-700">{t("phase2.forgotSuccessBody")}</p>
            {devResetUrl && (
              <div
                className="rounded-md bg-amber-50 border border-amber-200 px-3 py-2 text-xs text-amber-900 break-all"
                data-testid="forgot-dev-reset-url"
              >
                <span className="font-bold">{t("phase2.mockModeLabel")} · </span>
                <a href={devResetUrl} className="underline decoration-dotted">
                  {devResetUrl}
                </a>
              </div>
            )}
            <div className="flex gap-3">
              <Link to="/login" className="tsw-btn-secondary" data-testid="forgot-back-login">
                {t("phase2.backToLogin")}
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="tsw-card p-6 sm:p-8 space-y-5" data-testid="forgot-form">
            <div>
              <label className="tsw-label">{t("auth.email")}</label>
              <input
                type="email"
                required
                className="tsw-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email"
              />
            </div>
            <button type="submit" className="tsw-btn-primary w-full" disabled={loading} data-testid="forgot-submit">
              {loading ? t("common.loading") : t("phase2.sendResetLink")}
            </button>
            <div className="text-center text-sm text-slate-500">
              <Link to="/login" className="text-emerald-700 font-medium" data-testid="forgot-to-login">
                {t("phase2.backToLogin")}
              </Link>
            </div>
          </form>
        )}
      </div>
    </PublicLayout>
  );
};

export default ForgotPassword;
